import axios from "axios";

const apiKey = process.env.REACT_APP_API_CODE;

const baseUrl = process.env.REACT_APP_BASE_URL;

// Create an Axios instance for API requests
export const apiClient = axios.create({
  baseURL: baseUrl,
  timeout: 120000,
});

// Add an interceptor to set authorization header with user token before requests
apiClient.interceptors.request.use(
  function (config) {

    const userToken = JSON.parse(window.localStorage.getItem("userInfo"));

    config.headers.Authorization = `Bearer ${userToken?.access_token}`;
    config.headers.apiKey = apiKey;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

apiClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  return config;
});

const getRestaurantEvent = (id, eventName) => {
  return apiClient.get(`restaurantevent/${id}/name/${eventName}`);
};


const getSingleTicket = (id) => {
  return apiClient.get(`restaurantevent/ticket/${id}`);
};

const sendBooking = (
  eventId,
  tickets,
  firstName,
  lastName,
  emailAddress,
  phoneNumber,
  referralCode,
  groupMemberDietaryRestriction,
  specialRequest,
  amount,
  paymentMethod,
  reference,
  time,
  date,
) => {
  const bookingPayment = {
    amount,
    paymentMethod,
    payStackTransactionId: reference,
  };
  const payload = {
    amount,
    email: emailAddress,
    reference,
    metadata: {
      eventId,
      tickets,
      firstName,
      lastName,
      emailAddress,
      phoneNumber,
      referralCode,
      groupMemberDietaryRestriction,
      specialRequest,
      time,
      date: date || null,
      bookingPayment,
    },
  };

  console.log(payload, "Payload");
  return apiClient.post("payment/tickets/access_code", payload);
};
// const sendBooking = (
//   eventId,
//   ticketId,
//   noOfGuest,
//   firstName,
//   lastName,
//   emailAddress,
//   phoneNumber,
//   referralCode,
//   groupMemberDietaryRestriction,
//   specialRequest,
//   amount,
//   paymentMethod,
//   reference,
//   time,
//   tickets // optional: array of selected tickets for multi-ticket bookings
// ) => {
//   const bookingPayment = {
//     amount,
//     paymentMethod,
//     payStackTransactionId: reference,
//   };
//   const payload = {
//     eventId,
//     amount,
//     email: emailAddress,
//     reference,
//     metadata: {
//       ticketId,
//       noOfGuest,
//       firstName,
//       lastName,
//       emailAddress,
//       phoneNumber,
//       referralCode,
//       groupMemberDietaryRestriction,
//       specialRequest,
//       time,
//       tickets,
//       bookingPayment,
//     },
//   };

//   console.log(payload, "Payload");
//   return apiClient.post("payment/ticket/access_code", payload);
// };

const sendBookingNonTicketed = (
  eventId,
  tickets,
  firstName,
  lastName,
  emailAddress,
  phoneNumber,
  referralCode,
  groupMemberDietaryRestriction,
  specialRequest,
  time,
  noOfGuest,
  date,
) => {
  const payload = {
    eventId,
    tickets,
    noOfGuest,
    firstName,
    lastName,
    emailAddress,
    phoneNumber,
    referralCode,
    groupMemberDietaryRestriction,
    specialRequest,
    time,
    date: date || null,
    bookingPayment: {
      amount: 0,
      paymentMethod: "NoPayment",
      payStackTransactionId: null,
    },
  };

  return apiClient.post("/restaurantevent/ticket/book", payload);
};
// const sendBookingNonTicketed = (
//   eventId,
//   ticketId,
//   noOfGuest,
//   firstName,
//   lastName,
//   emailAddress,
//   phoneNumber,
//   referralCode,
//   groupMemberDietaryRestriction,
//   specialRequest,
//   time
// ) => {
//   const payload = {
//     eventId,
//     ticketId,
//     noOfGuest,
//     firstName,
//     lastName,
//     emailAddress,
//     phoneNumber,
//     referralCode,
//       groupMemberDietaryRestriction,
//   specialRequest,
//     time,
//     bookingPayment: {
//       amount: 0,
//       paymentMethod: "NoPayment",
//       payStackTransactionId: null,
//     },
//   };

//   return apiClient.post("/restaurantevent/ticket/book", payload);
// };

const verifyBooking = (ref) => {
  return apiClient.get(`webhook/verify/multiple-tickets?reference=${ref}`);
};
const getEventOverview = (name) => {
  return apiClient.get(`restaurantevent/overview?restaurantName=${name}`);
};

const getEventTimeInterval = (eventId) => {
  return apiClient.get(`restaurantevent/${eventId}/buffers
`);
};


const getTicketCharges = (restaurantId, getTicketPrices, taxPercantage) => {
  const payload = {
  restaurantId,
  getTicketPrices,
  taxPercantage
}
  return apiClient.post(`/restaurantevent/ticket/cost`, payload)
}

export {
  getRestaurantEvent,
  getSingleTicket,
  sendBooking,
  verifyBooking,
  getEventTimeInterval,
  sendBookingNonTicketed,
  getTicketCharges,
  getEventOverview
};
